import { render, staticRenderFns } from "./client.vue?vue&type=template&id=7fdf9932&scoped=true&"
import script from "./client.vue?vue&type=script&lang=js&"
export * from "./client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf9932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdf9932')) {
      api.createRecord('7fdf9932', component.options)
    } else {
      api.reload('7fdf9932', component.options)
    }
    module.hot.accept("./client.vue?vue&type=template&id=7fdf9932&scoped=true&", function () {
      api.rerender('7fdf9932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/clientServer/client.vue"
export default component.exports